import { useQuery } from "@tanstack/react-query";
import {
	applicationSessionsApi,
	type GetApplicationSessionsParams,
} from "@services/applicationSessions.service";
import { QUERY_KEYS } from "@constants/api.routes";

interface UseApplicationSessionsOptions {
	enabled?: boolean;
}

export const useApplicationSessions = (
	params?: GetApplicationSessionsParams,
	options?: UseApplicationSessionsOptions,
) => {
	const current = params?.current === true;
	const certified = params?.certified === true;
	const preferRenew = params?.preferRenew === true;
	const renewal = params?.renewal === true;
	const queryParams: GetApplicationSessionsParams | undefined =
		current || certified || preferRenew || renewal
			? {
					...(current ? { current: true } : {}),
					...(certified ? { certified: true } : {}),
					...(preferRenew ? { preferRenew: true } : {}),
					...(renewal ? { renewal: true } : {}),
				}
			: undefined;

	return useQuery({
		queryKey: [QUERY_KEYS.APPLICATION_SESSIONS, { current, certified, preferRenew, renewal }],
		queryFn: () => applicationSessionsApi.getApplicationSessions(queryParams),
		enabled: options?.enabled ?? true,
		staleTime: 5 * 60 * 1000,
		gcTime: 10 * 60 * 1000,
	});
};
